import React from "react";
import { useState } from "react";
import { CSVLink } from "react-csv";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
// import searchWhiteIcon from "./Icon.png";
// import "./OMSReturns.css";
import NavBar from "../NavBar";
export default function OMSReturns(props) {
  const [count, setCount] = useState([]);
  const [filtr1, setFiltr1] = useState("");
  const [filtr2, setFiltr2] = useState("");


  const handleFilter1 = (e) => {
    setFiltr1(e.target.value);
    setCount(IncomingData.filter((x) => x.deliveryStatus === e.target.value));
  };  
  const handleFilter2 = (e) => {
    setFiltr2(e.target.value);
    setCount(IncomingData.filter((x) => x.issue === e.target.value));
  };
  return (
    <>
      <NavBar />
      <div>
        <p className="title">
          <span className="title_line"></span>
          <span className="account_title">Order Management</span>
          <span className="color"> &#62; </span>
          <span className="color"> Returns</span>
        </p>
      </div>
      <div id="Right-content-Down-First">
        <h2>Returns</h2>
        <div id="Right-content-Down-Filters">
          <div
            style={{
              "border-left": "5px dotted rgba(0, 0, 0, 0.989)",
              height: "80%",
            }}
          ></div>
        </div>
      </div>
      <div id="OMS-main-content">
        <div className="order-list-box" style={{ width: "99%" }}>
          <div id="click-data">
            <p>All Orders</p>
            <p>Confirmed</p>
            <p>Cancelled</p>
          </div>
          <div className="order-list-input-box">
            <div className="order-list-input-left">
            <input
              type="text"
              placeholder="Search by order ID, customer name"
              onChange={(val) => {
                setCount(
                    IncomingData.filter((x) =>
                    x.id.match(val.target.value) || x.customerName.match(val.target.value)
                  )
                );
                setFiltr1("");
                setFiltr2("");

              }}
              />               {/* <img src={searchWhiteIcon} alt="" width="" /> */}
            </div>
            <div className="order-list-input-right">
              <select name="" id="" className="order-list-input-right-filters"
               value={filtr2}
              onChange={handleFilter2}
              >
                <option value="" selected>
                  Issue
                </option>
                <option value="Size">Size</option>
                <option value="Quality">Quality</option>
                <option value="Similarity">Similarity</option>
                <option value="Model">Model</option>
              </select>
              <select name="" id="" className="order-list-input-right-filters"
               value={filtr1}
              onChange={handleFilter1}
              >
                <option selected>Order Status</option>
                <option value="Delivered">Delivered</option>
                <option value="Not received">Not received</option>
                <option value="Just requested">Just requested</option>
              </select>
              <CSVLink
              data={IncomingData}
              className="supplier-content-input-right-filters"
              style={{ display: "flex", alignItems: "center" }}
            >
              Explore List
              <OpenInNewIcon
                style={{ fontSize: "16", marginLeft: "5" }}
              ></OpenInNewIcon>
            </CSVLink>
            </div>
          </div>
          <table style={{ textAlign: "center" }}>
            <tr>
              <th>Order ID</th>
              <th>Customer Name</th>
              <th>Returned Item</th>
              <th>Purchase Date</th>
              <th>Amount</th>
              <th>Delivery Status</th>
              <th>Payment Method</th>
              <th>Issue</th>
              <th>Rating</th>
            </tr>
            {count.length > 0
            ? count.map((val) => {
                return (
                  <tr>
                  <td>{val.id}</td>
                  <td>{val.customerName}</td>
                  <td>{val.returnedItem}</td>
                  <td>{val.purchaseDate}</td>
                  <td>{val.amount}</td>
                  <td className="col-status"
                      id={
                        val.deliveryStatus === "Delivered"
                          ? "col-green"
                          : val.deliveryStatus === "Just requested"
                          ? "red-border-status"
                          : val.deliveryStatus === "Not received"
                          ? "red-border-status"
                          : ""
                      }>{val.deliveryStatus}</td>
                  <td>{val.paymentMethod}</td>
                  <td>{val.issue}</td>
                  <td>{val.rating}</td>
                </tr>
                );
              })
            : IncomingData.map((val) => {
              return (
                <tr>
                  <td>{val.id}</td>
                  <td>{val.customerName}</td>
                  <td>{val.returnedItem}</td>
                  <td>{val.purchaseDate}</td>
                  <td>{val.amount}</td>
                  <td  className="col-status"
                      id={
                        val.deliveryStatus === "Delivered"
                          ? "col-green"
                          : val.deliveryStatus === "Just requested"
                          ? "red-border-status"
                          : val.deliveryStatus === "Not received"
                          ? "red-border-status"
                          : ""
                      }>{val.deliveryStatus}</td>
                  <td>{val.paymentMethod}</td>
                  <td>{val.issue}</td>
                  <td>{val.rating}</td>
                </tr>
              );
            })}
          </table>
        </div>
      </div>
    </>
  );
}
export const IncomingData = [
  {
    id: "KCVF7777",
    customerName: "Hikaru",
    returnedItem: `Nike men's air zoom shoe`,
    purchaseDate: "12 - 12 - 12",
    amount: 9995,
    deliveryStatus: "Delivered",
    paymentMethod: "UPI",
    issue: 'Size',
    rating: '1.0'
  },
  {
    id: "KCVF112L",
    customerName: "Hikaru",
    returnedItem: `Nike men's air zoom shoe`,
    purchaseDate: "12 - 12 - 12",
    amount: 9995,
    deliveryStatus: "Delivered",
    paymentMethod: "UPI",
    issue: 'Size',
    rating: '3.0'
  },
  {
    id: "KCVF112L",
    customerName: "John Doe",
    returnedItem: `Nike men's air zoom shoe`,
    purchaseDate: "12 - 12 - 12",
    amount: 9995,
    deliveryStatus: "Just requested",
    paymentMethod: "UPI",
    issue: 'Quality',
    rating: '4.0'
  },
  {
    id: "KCVF112L",
    customerName: "Hikaru",
    returnedItem: `Nike men's air zoom shoe`,
    purchaseDate: "12 - 12 - 12",
    amount: 9995,
    deliveryStatus: "Just requested",
    paymentMethod: "UPI",
    issue: 'Size',
    rating: '1.0'
  },
  {
    id: "KCVF112L",
    customerName: "Magnus",
    returnedItem: `Nike men's air zoom shoe`,
    purchaseDate: "12 - 12 - 12",
    amount: 9995,
    deliveryStatus: "Delivered",
    paymentMethod: "UPI",
    issue: 'Quality',
    rating: '8.0'
  },
  {
    id: "KCVF112L",
    customerName: "John Doe",
    returnedItem: `Nike men's air zoom shoe`,
    purchaseDate: "12 - 12 - 12",
    amount: 9995,
    deliveryStatus: "Just requested",
    paymentMethod: "UPI",
    issue: 'Similarity',
    rating: '1.0'
  },
  {
    id: "KCVF112L",
    customerName: "Dom",
    returnedItem: `Nike men's air zoom shoe`,
    purchaseDate: "12 - 12 - 12",
    amount: 9995,
    deliveryStatus: "Just requested",
    paymentMethod: "UPI",
    issue: 'Size',
    rating: '1.0'
  },
  {
    id: "KCVF112L",
    customerName: "John Doe",
    returnedItem: `Nike men's air zoom shoe`,
    purchaseDate: "12 - 12 - 12",
    amount: 9995,
    deliveryStatus: "Delivered",
    paymentMethod: "UPI",
    issue: 'Quality',
    rating: '1.0'
  },
  {
    id: "KCVF112L",
    customerName: "John Doe",
    returnedItem: `Nike men's air zoom shoe`,
    purchaseDate: "12 - 12 - 12",
    amount: 9995,
    deliveryStatus: "Delivered",
    paymentMethod: "UPI",
    issue: 'Similarity',
    rating: '1.0'
  },
  {
    id: "KCVF112L",
    customerName: "John Doe",
    returnedItem: `Nike men's air zoom shoe`,
    purchaseDate: "12 - 12 - 12",
    amount: 9995,
    deliveryStatus: "Delivered",
    paymentMethod: "UPI",
    issue: 'Quality',
    rating: '1.0'
  },
  {
    id: "KCVF112L",
    customerName: "John Doe",
    returnedItem: `Nike men's air zoom shoe`,
    purchaseDate: "12 - 12 - 12",
    amount: 9995,
    deliveryStatus: "Delivered",
    paymentMethod: "UPI",
    issue: 'Similarity',
    rating: '1.0'
  },
  {
    id: "KCVF112L",
    customerName: "John Doe",
    returnedItem: `Nike men's air zoom shoe`,
    purchaseDate: "12 - 12 - 12",
    amount: 9995,
    deliveryStatus: "Delivered",
    paymentMethod: "UPI",
    issue: 'Size',
    rating: '1.0'
  },
  {
    id: "KCVF112L",
    customerName: "John Doe",
    returnedItem: `Nike men's air zoom shoe`,
    purchaseDate: "12 - 12 - 12",
    amount: 9995,
    deliveryStatus: "Delivered",
    paymentMethod: "UPI",
    issue: 'Similarity',
    rating: '1.0'
  },
  {
    id: "KCVF112L",
    customerName: "John Doe",
    returnedItem: `Nike men's air zoom shoe`,
    purchaseDate: "12 - 12 - 12",
    amount: 9995,
    deliveryStatus: "Delivered",
    paymentMethod: "UPI",
    issue: 'Size',
    rating: '1.0'
  },
  {
    id: "KCVF112L",
    customerName: "John Doe",
    returnedItem: `Nike men's air zoom shoe`,
    purchaseDate: "12 - 12 - 12",
    amount: 9995,
    deliveryStatus: "Delivered",
    paymentMethod: "UPI",
    issue: 'Size',
    rating: '1.0'
  },
  {
    id: "KCVF112L",
    customerName: "John Doe",
    returnedItem: `Nike men's air zoom shoe`,
    purchaseDate: "12 - 12 - 12",
    amount: 9995,
    deliveryStatus: "Delivered",
    paymentMethod: "UPI",
    issue: 'Size',
    rating: '1.0'
  },
  {
    id: "KCVF112L",
    customerName: "John Doe",
    returnedItem: `Nike men's air zoom shoe`,
    purchaseDate: "12 - 12 - 12",
    amount: 9995,
    deliveryStatus: "Delivered",
    paymentMethod: "UPI",
    issue: 'Size',
    rating: '1.0'
  },
  {
    id: "KCVF112L",
    customerName: "John Doe",
    returnedItem: `Nike men's air zoom shoe`,
    purchaseDate: "12 - 12 - 12",
    amount: 9995,
    deliveryStatus: "Delivered",
    paymentMethod: "UPI",
    issue: 'Size',
    rating: '1.0'

  },
  {
    id: "KCVF112L",
    customerName: "John Doe",
    returnedItem: `Nike men's air zoom shoe`,
    purchaseDate: "12 - 12 - 12",
    amount: 9995,
    deliveryStatus: "Delivered",
    paymentMethod: "UPI",
    issue: 'Size',
    rating: '1.0'
  },
  {
    id: "KCVF112L",
    customerName: "John Doe",
    returnedItem: `Nike men's air zoom shoe`,
    purchaseDate: "12 - 12 - 12",
    amount: 9995,
    deliveryStatus: "Delivered",
    paymentMethod: "UPI",
    issue: 'Size',
    rating: '1.0'
  },
  {
    id: "KCVF112L",
    customerName: "John Doe",
    returnedItem: `Nike men's air zoom shoe`,
    purchaseDate: "12 - 12 - 12",
    amount: 9995,
    deliveryStatus: "Delivered",
    paymentMethod: "UPI",
    issue: 'Size',
    rating: '1.0'
  },
  {
    id: "KCVF112L",
    customerName: "John Doe",
    returnedItem: `Nike men's air zoom shoe`,
    purchaseDate: "12 - 12 - 12",
    amount: 9995,
    deliveryStatus: "Delivered",
    paymentMethod: "UPI",
    issue: 'Size',
    rating: '1.0'
  },
];
